export const SCHOOL_CREATION_ERROR_MESSAGE =
  "Unable to create the school. Please try again or contact support.";

type SchoolCreationErrorData = {
  error?: string | {
    body?: string;
    title?: string;
    message?: string;
    details?: { message?: string }[];
  };
  message?: string;
};

export function getSchoolCreationErrorMessage(data: unknown, status?: number): string {
  // Server failures can include database errors and stack traces. Only show
  // the API's validation/business messages for requests it could process.
  if (status !== undefined && status >= 500) return SCHOOL_CREATION_ERROR_MESSAGE;
  if (!data || typeof data !== "object") return SCHOOL_CREATION_ERROR_MESSAGE;

  const payload = data as SchoolCreationErrorData;
  const error = payload.error;
  const message = typeof error === "string"
    ? error
    : error?.body || error?.details?.[0]?.message || error?.message || error?.title || payload.message;

  return typeof message === "string" && message.trim()
    ? message
    : SCHOOL_CREATION_ERROR_MESSAGE;
}
